<template>
  <video
    ref="videoElement"
    :key="videoSrc"
    :src="videoSrc"
    class="h-full w-full bg-black object-contain"
    :autoplay="autoplay"
    controls
    playsinline
    webkit-playsinline="true"
    preload="metadata"
    @canplay="handleCanPlay"
  >
    Ваш браузер не поддерживает видео.
  </video>
</template>

<script setup lang="ts">
import { nextTick, ref, watch } from "vue";

const props = withDefaults(
  defineProps<{
    videoSrc: string;
    autoplay?: boolean;
  }>(),
  {
    autoplay: true,
  },
);

const videoElement = ref<HTMLVideoElement | null>(null);

const playVideo = async () => {
  if (!props.autoplay) return;

  const element = videoElement.value;
  if (!element) return;

  try {
    await element.play();
  } catch {
    // Mobile browsers may still block autoplay until an explicit user gesture.
  }
};

const handleCanPlay = () => {
  void playVideo();
};

watch(
  () => [props.videoSrc, props.autoplay],
  async () => {
    await nextTick();
    void playVideo();
  },
  { immediate: true },
);
</script>
